import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Pipeline2vw6c5wpzxajt as Pipeline } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/Pipeline.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PhasesClass;
function Phases() {
  if (PhasesClass === VOID) {
    class $ {
      constructor() {
        Phases_instance = this;
        this.x5g_1 = new (PipelinePhase())('Before');
        this.y5g_1 = new (PipelinePhase())('State');
        this.z5g_1 = new (PipelinePhase())('Monitoring');
        this.a5h_1 = new (PipelinePhase())('Engine');
        this.b5h_1 = new (PipelinePhase())('Receive');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass = $;
  }
  return PhasesClass;
}
var Phases_instance;
function Phases_getInstance() {
  if (Phases_instance === VOID)
    new (Phases())();
  return Phases_instance;
}
var HttpSendPipelineClass;
function HttpSendPipeline() {
  if (HttpSendPipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance().x5g_1, Phases_getInstance().y5g_1, Phases_getInstance().z5g_1, Phases_getInstance().a5h_1, Phases_getInstance().b5h_1]);
        this.e5v_1 = developmentMode;
      }
      v4s() {
        return this.e5v_1;
      }
    }
    initMetadataForClass($, 'HttpSendPipeline', HttpSendPipeline, VOID, VOID, [2]);
    HttpSendPipelineClass = $;
  }
  return HttpSendPipelineClass;
}
var PhasesClass_0;
function Phases_0() {
  if (PhasesClass_0 === VOID) {
    class $ {
      constructor() {
        Phases_instance_0 = this;
        this.h5m_1 = new (PipelinePhase())('Before');
        this.i5m_1 = new (PipelinePhase())('State');
        this.j5m_1 = new (PipelinePhase())('Transform');
        this.k5m_1 = new (PipelinePhase())('Render');
        this.l5m_1 = new (PipelinePhase())('Send');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass_0 = $;
  }
  return PhasesClass_0;
}
var Phases_instance_0;
function Phases_getInstance_0() {
  if (Phases_instance_0 === VOID)
    new (Phases_0())();
  return Phases_instance_0;
}
var HttpRequestPipelineClass;
function HttpRequestPipeline() {
  if (HttpRequestPipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance_0();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance_0().h5m_1, Phases_getInstance_0().i5m_1, Phases_getInstance_0().j5m_1, Phases_getInstance_0().k5m_1, Phases_getInstance_0().l5m_1]);
        this.m5v_1 = developmentMode;
      }
      v4s() {
        return this.m5v_1;
      }
    }
    initMetadataForClass($, 'HttpRequestPipeline', HttpRequestPipeline, VOID, VOID, [2]);
    HttpRequestPipelineClass = $;
  }
  return HttpRequestPipelineClass;
}
//region block: exports
export {
  Phases_getInstance_0 as Phases_getInstance27czzec4fvnke,
  Phases_getInstance as Phases_getInstance2m4et9xkapx2y,
  HttpRequestPipeline as HttpRequestPipeline1v7xct5dgezuy,
  HttpSendPipeline as HttpSendPipeline3tm1hram7cjxt,
};
//endregion

//# sourceMappingURL=HttpRequestPipeline.mjs.map
